import { useMemo } from "react";
import { useGetBoMeQuery } from "../store/services/api";
import { getTenantBrandColor } from "../utils/functions/tenantThemeColor";

/**
 * Color de marca por tenant, con el mismo merge que frontend-app (`mergeTenantTheme`):
 * se lee `tenant.theme` de /bo/me y se resuelve el primary (custom o defaultTheme).
 */
export function useTenantBrandColors(): Record<string, string> {
  const { data: me } = useGetBoMeQuery();

  return useMemo(() => {
    const colors: Record<string, string> = {};
    (me?.tenants ?? []).forEach((tenant) => {
      colors[tenant.id] = getTenantBrandColor(tenant.theme);
    });
    return colors;
  }, [me?.tenants]);
}
